import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';

@Pipe({
    name: 'timezoneAbbreviation',
    standalone: false
})
export class TimezoneAbbreviationPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) {
      return;
    }

    return moment().tz(value).format('z') || value;
  }
}
